const mFeedProjectsContentModalCreate = {
  mFeedProjectsContentModalCreate: {
    alerts: {
      createProyecto: {
        error: 'Un error ha ocurrido. Verifica los datos ingresados y vuelve a intentarlo.',
        success: 'La formación fue creada exitosamente.'
      }
    },

    buttonCancel: 'CANCELAR',
    buttonPrimary: 'CREAR',

    inputs: {
      option: {
        labelAsset: 'Curso',
        labelMap: 'Mapa'
      },

      titulo: {
        label: 'Escribe aquí un nombre',
        message: '* De 5 a 120 caracteres'
      }
    },

    title: 'Nueva Formación',

    validation: {
      option: {
        required: 'Una opción es requerida.'
      },

      titulo: {
        maxLength: 'La longitud máxima permitida es de 120 caracteres.',
        minLength: 'La longitud mínima permitida es de 5 caracteres.',
        required: 'Nombre de formación es requerido. De 5 a 120 caracteres.'
      }
    }
  }
}

export default mFeedProjectsContentModalCreate
